import { render, staticRenderFns } from "./ChartNotificationsByClient.vue?vue&type=template&id=01757e04&scoped=true&"
import script from "./ChartNotificationsByClient.vue?vue&type=script&lang=js&"
export * from "./ChartNotificationsByClient.vue?vue&type=script&lang=js&"
import style0 from "./ChartNotificationsByClient.vue?vue&type=style&index=0&id=01757e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01757e04",
  null
  
)

export default component.exports